export default {
    validate(value, start) {
        return value.startsWith(start);
    }
};